import * as React from 'react';
import * as classNames from 'classnames';
import * as moment from 'moment';
import { Icon } from '@ridi/rsg';

declare var global: {
  Ridi: {
    globals: {
      isMobile: boolean;
    }
  }
};

export interface BookEvent {
  eventId: number;
  groupName: string;
  startDate: string;
  endDate: string;
}

interface Props {
  event: BookEvent;
}

export function NoticeEventItem(props: Props) {
  const {
    event: {
      eventId,
      groupName,
      startDate,
      endDate,
    },
  } = props;

  const start = moment(new Date(startDate)).locale('ko');
  const end = moment(new Date(endDate)).locale('ko');
  const periodExposure = moment.isMoment(start) && end.diff(moment(), 'years') < 2;

  return (
    <li
      className={classNames(
        'BookDetailNotice_List_Item',
        'BookDetailNotice_List_Item-event',
        { 'BookDetailNotice_List_Item-hasPeriod': periodExposure },
      )}
    >
      <a href={`/event/${eventId}`}>
        <div className="BookDetailNotice_List_Item_Title">{groupName}</div>
        <Icon
          className="BookDetailNotice_List_Item_ArrowIcon"
          name="arrow_2_right"
        />
      </a>
    </li>
  )
};



// WEBPACK FOOTER //
// ./pages/bookDetail/components/Notice/items/NoticeEventItem.tsx